var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOverall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Overall Events",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Overall Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0123,10.5c0,5.8-9.997,14.5-9.997,14.5C10.0153,25,.01825,16.3,.01825,10.5-.11646,4.84036,4.35748,.1413,10.0153,0c5.6578,.1413,10.1318,4.84036,9.997,10.5Z",
    fill: "#d11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7951,12.7458L11.1788,4.70512c-.3998-.69658-1.25074-.91388-1.9006-.48536-.18432,.12154-.33942,.2878-.45281,.48536L4.20906,12.7458c-.26767,.4554-.2791,1.0319-.0297,1.4989,.24376,.4684,.70574,.7577,1.20604,.7553H14.6187c.7634-.0006,1.3818-.6643,1.3813-1.4826-.0002-.2737-.0711-.542-.2049-.7752v.0036Zm-5.4829-.3378c-.0162,.0442-.0416,.0838-.0742,.1158-.1241,.1398-.33043,.1453-.4609,.0124l-.01158-.0124c-.03285-.0319-.05828-.0715-.07424-.1158-.01859-.043-.02782-.09-.027-.1374-.0015-.0475,.00776-.0947,.027-.1375,.01575-.0465,.04113-.0885,.07424-.123,.13276-.1337,.33968-.1337,.47238,0,.0329,.0347,.0583,.0767,.0743,.123,.0192,.0428,.0285,.09,.027,.1375,.0008,.0474-.0084,.0944-.027,.1374Zm.0277-1.6161c0,.1998-.1511,.3617-.3375,.3617-.18635,0-.33743-.1619-.33743-.3617v-2.88134c0-.19977,.15108-.36171,.33743-.36171,.1864,0,.3375,.16194,.3375,.36171v2.88134Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverall);
export default __webpack_public_path__ + "static/media/overall.db77cd9b99f185b6fffc1a1b416db2f4.svg";
export { ForwardRef as ReactComponent };